export default __webpack_public_path__ + "static/media/hog.1c8b9a0c.png";